/**
 * Tour steps for the DietTable component.
 *
 * @param {Function} t - The i18next translation function from `useTranslation()`.
 * @returns {import('react-joyride').Step[]}
 */
export const getDietTableSteps = (t) => [
    {
        target: '[data-tour="dt-info"]',
        title: t('tour.dietTable.step-info-title'),
        content: t('tour.dietTable.step-info-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="dt-day-selector"]',
        title: t('tour.dietTable.step-day-selector-title'),
        content: t('tour.dietTable.step-day-selector-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="dt-total-row"]',
        title: t('tour.dietTable.step-totals-title'),
        content: t('tour.dietTable.step-totals-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="dt-meal-header"]',
        title: t('tour.dietTable.step-meal-header-title'),
        content: t('tour.dietTable.step-meal-header-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="dt-table-container"]',
        title: t('tour.dietTable.step-table-title'),
        content: t('tour.dietTable.step-table-content'),
        disableBeacon: true,
        placement: 'top',
    },
];
